module.exports = {
    Description: {
        StaticInfo: `<p>When selecting the service company that will carry out the operation, it must be guaranteed that it is the one with the best indicators of efficiency, safety and service within the budgetary allocations for the Project. The available budget will dictate if the choice stays within first tier or qualified companies outside the first tier group. The potential materials suppliers must meet the standards of the operating company and even exceed them, and must all work together to achieve the agreed objectives.</p>`,
        SectionsInfo: []
    },
    Overview: {
        StaticInfo: `<p>The procedure to carry out the selection of the best suppliers is not an easy task, since the criteria to be followed to contract the best supplier have to be considered; Each operating company has its own policies to meet this objective. However, it is imperative to ensure that the provider to be selected can effectively meet the requirements for the execution of the operations that are required to be performed.</p>`,
        SectionsInfo: [{
                title: "Generally, for the selection of a service company, several stages are to be followed",
                content: `
          <ul>
      <li>A committee of specialists within the company is appointed to review the resources, finance, and taxes, forming a highly qualified team. </li>
      <li>This committee of specialists must identify the specific criteria for choosing the service supplier company, based on the company philosophy, including the experienced personnel, as well as the requirements of the specialists that need to be hired.</li>
      <li>When evaluating the different service companies, the committee identifies for each specific task, both the qualitative and quantitative factors for contracting that have to be considered.</li>
    </ul>
          `
            },
            {
                title: "Some of the factors to be evaluated are the following",
                content: `
          <ul>
      <li>Economic stability</li>
      <li>Current situation (if the company has ongoing legal processes, etc.)</li>
      <li>Credentials of the representatives</li>
      <li>Ability to meet the needs of the company</li>
      <li>Required technology</li>
      <li>Fit with the philosophy of the client</li>
      <li>Training of substitute personnel</li>
      <li>Professional qualifications of employees</li>
      <li>Importance of the localities in which it operates</li>
      <li>A summary of their history of the last five years (lawsuits, comments from other clients, other companies)</li>
      <li>Criteria followed to set the  price of the services offered</li>
      <li>Assistance offered to the Client</li>
    </ul>
          `
            },
            {
                title: "Among the technical criteria to evaluate the service companies, the following are suggested",
                content: `
        <ul>
      <li>Field experience in the area</li>
      <li>Availability to perform the job</li>
      <li>Integrated software to calculate fracture design, production forecast and costs</li>
      <li>Equipment to execute the fracturing  job, for a possible workover to the selected well, and to verify wellbore integrity</li>
      <li>The final fundamental criteria will be selected based on the specific conditions of the well and reservoir</li>
    </ul>
        `
            }
        ]
    },
    Inputs: {
        StaticInfo: `<p>In this section our purpose is to help the Client to select the most adequate service companies to perform the operation, in terms of expertise, quality, HSEQ management, designs, plans and operations cost, in order to guarantee that all the aspects needed for a successful operation are covered and met. Please consider uploading the information provided about the service company and other relevant data for analysis.</p> `,
        SectionsInfo: []
    },
    Deliverables: {
        StaticInfo: `<p> In this section the EGEP consultant will analyze and discuss the conclusions about the service companies and provide a report with such analysis, conclusions and recommendations.</p> `,
        SectionsInfo: []
    }
}